module.exports = __webpack_public_path__ + "media/images/logo-20minutes-alt-b2f7c55c92f7449c3ca359986e75eff4.png";